// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.social-btn {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
}
.social-btn:hover {
  text-decoration: underline;
}

.social-btn-title {
  padding: 0 8px 0 8px;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #6CE997;
  /* identical to box height, or 133% */
  letter-spacing: -0.5px;
  font-family: "SF Pro Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  text-decoration: none;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/social-button.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAAF;AAEE;EACE,0BAAA;AAAJ;;AAKA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qCAAA;EAEA,sBAAA;EACA,+IAAA;EAEA,qBAAA;EACA,eAAA;AAJF","sourcesContent":["\n.social-btn {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n}\n\n.social-btn-title {\n  padding: 0 8px 0 8px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 20px;\n  color: #6CE997;\n  /* identical to box height, or 133% */\n\n  letter-spacing: -0.5px;\n  font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\n  \n  text-decoration: none;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
